import { useEffect, useState } from "react";
import { FaCheck } from "react-icons/fa";

interface IProps {
  items: any[];
  color: string;
  size: number;
  border_color?: string;
  background: string;
  chave: number;
}

export default function CustomBox(props: IProps) {
  const [ativo, setAtivo] = useState(false);

  useEffect(() => {
    if (props.items) {
      console.log(props.chave);
      if (props?.items?.filter((e) => e?.chave === props?.chave)[0]) {
        setAtivo(true);
      } else {
        setAtivo(false);
      }
    }
  }, [props?.items]);


 const returnBackground = () => {
    if(ativo) return props.background;
    return 'rgba(0,0,0,0)'
 }

  return (
    <div
      style={{
        width: props.size,
        height: props.size,
        backgroundColor: returnBackground(),
        borderColor: props.border_color,
        marginRight: 10,
        marginBottom: 5,
        borderRadius: '50%',
        borderWidth: 1,
        borderStyle: "solid",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
      }}
    >
      {ativo && <FaCheck size={props.size * 0.6} color={props.color} />}
    </div>
  );
}
